/**
=========================================================
* Template for Dashboard
=========================================================
*/
import Header from "../../components/Header/Header";
import Navbar from "../../components/Navbar/Navbar"; 
function DashboardLayout({ children }) {  
  return(
    <>
    <Navbar/>
    <Header/>   
    <section className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">  
                  <div className="row"> 
                    <div className="col-sm-12">   
                        {children}  
                    </div> 
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> 
    </>
  );
} 

export default DashboardLayout;